import { OrganizationCalendarI, OrganizationInfo } from '@interfaces/organizationI';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Organiztions {
    organizations: OrganizationInfo[],
    organizationsM: OrganizationCalendarI[],
    invited?: {
        organizationIdLegacy?: number,
        organizationId?: string
    }
}

export const organizationSlice = createSlice({
    name: 'organization',
    initialState: {
        organizations: [],
        organizationsM: [],
        invited: undefined
    } as Organiztions,
    reducers: {
        setOrganizations: (state, action: PayloadAction<OrganizationInfo[]>) => {
            state.organizations = action.payload
        },
        setOrganizationsM: (state, action: PayloadAction<OrganizationCalendarI[]>) => {
            state.organizationsM = action.payload
        },
        setInvitation: (state, action: PayloadAction<string | number>) => {
            const id = action.payload
            if(typeof id === "string")
            {
                state.invited = { organizationId: id }
            }
            else
            {
                state.invited = { organizationIdLegacy: id }
            }
        },
        cleanInvitation: (state) => {
            state.invited = undefined
        },
        cleanOrganizationSlice: (state) => {
            state.invited = undefined
            state.organizations = []
            state.organizationsM = []
        }
    },
});

export const { setOrganizations, setOrganizationsM, setInvitation, cleanInvitation,cleanOrganizationSlice } = organizationSlice.actions;
export default organizationSlice.reducer;
